S.audioPreview = {
    config: {},
    elements: {
        $audio: null,
        $playButton: null,
        $stopButton: null,
    },

    /** @var audioTag */
    audioTag: null,

    init()
    {
        // save javascript element
        this.audioTag = this.elements.$audio.get(0);

        // init events
        this.initCustomAudioEvents();

        // slides are clickable - so prevent bubbling up the click event
        this.$module.on('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
        })
    },

    /**
     * handle click event and ended event
     */
    initCustomAudioEvents()
    {
        this.elements.$playButton.on('click', () =>
        {
            // stop all audio playing
            S.audioPreview.pauseAudio();

            // play - pause toggle
            this.playAudio();
        })

        this.elements.$stopButton.on('click', () =>
        {
            // play - pause toggle
            this.pauseAudio();
        })

        // listen for the end
        this.audioTag.addEventListener("ended",() => {
            this.$module.removeClass('is-playing');
        });
    },

    /**
     * play logic
     */
    playAudio()
    {
        this.audioTag.play();

        this.$module.addClass('is-playing');
    },

    /**
     * play logic
     */
    pauseAudio()
    {
        this.audioTag.pause();

        this.$module.removeClass('is-playing');
    }
}
